module.exports = __webpack_public_path__ + "media/images/pindown-a53d2d621617e980be33f2eca08027f7.png";